import styled from "styled-components"
import { motion } from "framer-motion"
import { Link } from "react-router-dom"
import LivingImage from "./living_room.jpg"
import { device } from "../../../theme/device"
import { IconButton } from "@material-ui/core"

export const Text1 = styled.p`
  font-family: OuterSans-Regular;
  font-style: normal;
  font-weight: 600;
  font-size: 1vw;
  color: #75938f;
  margin: 0;
  padding: 0;
  line-height: 350%;
`

export const Text2 = styled.p`
  font-family: AzoSans-Regular;
  font-style: normal;
  font-weight: 400;
  font-size: 0.7vw;
  color: #0a243c;
  margin: 0;
  padding: 0;
  line-height: 150%;
  @media ${device.padPro} {
    font-size: 0.85vw;
  }
`

export const Text3 = styled.p`
  font-family: AzoSans-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 0.7vw;
  color: #3a4653;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 0em;
`

export const Text4 = styled.p`
  font-family: NewParisKingSize-Regular;
  font-style: normal;
  font-weight: 4000;
  font-size: 1.7vw;
  color: #445654;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-bottom: 0em;
  max-width: 22em;
`

export const Holder = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 10000;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;
`

export const Content = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 100%;
`
export const LeftHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 42%;
  height: 100%;
`

export const MiddleHolder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 27%;
  height: 100%;
  padding: 2vw;
`

export const BestImage = styled.img`
  width: 100%;
  padding: 0 1vw;
`
export const FourImage = styled.img`
  width: 100%;
  padding: 0 1vw;
`

export const RightHolder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 31%;
  height: 100%;
  padding: 2vw;
`
export const CardImage = styled.img`
  width: 100%;
`

export const LeftPic = styled.div`
  width: 100%;
  height: 55%;
  background: url(${LivingImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`
export const LeftBottomHolder = styled.div`
  height: 45%;
  padding: 0.8vw 2vw 3.5rem 2vw;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 1vw;
`
export const TaylorPic = styled.img`
  width: 95%;
  pointer-events: none;
  user-select: none;
`
export const Divider = styled.div`
  width: 100%;
  height: 2px;
  margin: 0.1vw 0 1vw 0;
  background-color: #5f7774;
`

export const List = styled.ul`
  padding-top: 0.5vw;
`

export const ListItem = styled.li`
  font-family: AzoSans-Regular;
  font-weight: 400;
  font-size: 0.65vw;
  color: #0a243c;
  margin: 0;
  padding: 0;
  line-height: 150%;
  margin-top: 0.8em;
  @media ${device.padPro} {
    font-size: 0.85vw;
  }
`

export const AboutLink = styled(Link)`
  position: absolute;
  left: 1rem;
  bottom: 1rem;
`
export const BackButton = styled(IconButton)`
  width: 3em;
  height: 3em;
`
export const BackIcon = styled.img`
  width: 100%;
`
